import { Button } from '@linktivity/link-ui';

import styles from './stickyActionFooter.module.css';

export interface StickyActionFooterProps {
  label: string;
  disabled?: boolean;
  loading?: boolean;
  onClick: () => void;
}

const StickyActionFooter = ({
  label,
  disabled = false,
  loading = false,
  onClick
}: StickyActionFooterProps) => (
  <footer className={styles.footer}>
    <Button
      variant="filled"
      className={styles.button}
      disabled={disabled}
      loading={loading}
      onClick={onClick}
    >
      {label}
    </Button>
  </footer>
);

export default StickyActionFooter;
